import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  fullWidth = false,
  onClick,
  type = 'button',
  className = '',
  ...props
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-semibold rounded-lg transition-all duration-300 focus:outline-none focus:ring-4 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none';

  const variantClasses = {
    primary: 'bg-gradient-primary text-white shadow-primary hover:-translate-y-0.5 hover:shadow-lg focus:ring-primary-500/50',
    secondary: 'bg-gradient-to-br from-secondary-500 to-secondary-600 text-white shadow-md hover:-translate-y-0.5 hover:shadow-lg focus:ring-secondary-500/50',
    success: 'bg-gradient-success text-white shadow-success hover:-translate-y-0.5 hover:shadow-lg focus:ring-success-500/50',
    danger: 'bg-gradient-danger text-white shadow-danger hover:-translate-y-0.5 hover:shadow-lg focus:ring-danger-500/50',
    warning: 'bg-gradient-warning text-white shadow-md hover:-translate-y-0.5 hover:shadow-lg focus:ring-warning-500/50',
    info: 'bg-info-500 hover:bg-info-600 text-white shadow-md hover:-translate-y-0.5 hover:shadow-lg focus:ring-info-500/50',
    outline: 'bg-white border-2 border-neutral-300 text-text-primary hover:bg-neutral-50 hover:border-neutral-400 focus:ring-neutral-300/50',
    ghost: 'bg-transparent hover:bg-neutral-100 text-text-primary focus:ring-neutral-300/50',
  };

  const sizeClasses = {
    sm: 'px-3 py-1.5 text-sm gap-1.5',
    md: 'px-6 py-2.5 text-base gap-2',
    lg: 'px-8 py-3 text-lg gap-2.5',
    xl: 'px-10 py-4 text-xl gap-3',
  };

  const widthClass = fullWidth ? 'w-full' : '';

  const combinedClasses = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${widthClass} ${className}`;

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={combinedClasses}
      {...props}
    >
      {loading && (
        <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      )}
      {children}
    </button>
  );
};

export default Button;
